import React from 'react'
import { getSwapForMe, getSwapForYou, getSwapShippingInfo } from '../../utils'
import { themeColors } from '../../styles/theme'

const styles = {
  message: {
    fontSize: 14,
    paddingLeft: 5,
    paddingRight: 5,
  },
  address: {
    color: themeColors.energized,
    fontWeight: 'bold',
  },
}

const ShipTo = ({ user }) => (
  <div>
    <p>Indirizzo spedizione:</p>
    <p style={styles.address}>
      {user.nome}
      {' - '}
      {user.address}
      {' - '}
      {user.zip}
      {' '}
      {user.city}
      {' '}
      {user.district}
    </p>
  </div>
)

const SwapShippingInfo = ({ swap, user }) => {
  const shippingInfo = getSwapShippingInfo(swap)
  const swapForMe = getSwapForMe(swap, user)
  const swapForYou = getSwapForYou(swap, user)

  if (shippingInfo === null) {
    // Nessono deve spedire per primo
    return (
      <div style={styles.message}>
        <ShipTo user={swapForYou.user} />
      </div>
    )
  } else if (swapForMe.user.id === shippingInfo.user.id) {
    return (
      <div style={styles.message}>
        Devi spedire tu per primo. {swapForYou.user.nome}
        {' '}ti invierà il suo oggetto dopo aver ricevuto il tuo.
        Per maggiori informazioni
        {' '}
        <a href="/come-funziona" rel="noopener noreferrer" target="_blank">
          leggi qui.
        </a>
        <ShipTo user={swapForYou.user} />
      </div>
    )
  } else {
    return (
      <div style={styles.message}>
        {swapForYou.user.nome} deve spedire per primo.
        Attendi di ricevere il suo oggetto prima di inviare il tuo.
        Per maggiori informazioni
        {' '}
        <a
          href="/come-funziona"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: themeColors.energized, textDecoration: 'underline' }}>
          leggi qui.
        </a>
        <ShipTo user={swapForYou.user} />
      </div>
    )
  }
}

export default SwapShippingInfo



// WEBPACK FOOTER //
// ./src/common/Swap/SwapShippingInfo.js